import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../components/auth/AuthContext';
import {
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
} from '@mui/material';
import axios from 'axios';

const TeacherDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { teacher } = location.state || {};
  const { schoolId } = useAuth();

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editForm, setEditForm] = useState({
    fullName: teacher?.fullName || '',
    email: teacher?.email || '',
    phoneNumber: teacher?.phoneNumber || '',
    subjectSpecialization: teacher?.subjectSpecialization || '',
    tscNumber: teacher?.tscNumber || '',
    classRepresenting: teacher?.classRepresenting || '',
  });

  const handleEdit = async () => {
    try {
      const response = await axios.put(`https://kidsm.vercel.app/api/schools/teachers/${teacher?._id}`, {
        ...editForm,
        schoolId,
      });
      if (response.status === 200) {
        alert('Success: Teacher details updated successfully!');
        setIsEditModalOpen(false);
        navigate(-1);
      }
    } catch (error) {
      console.error('Error updating teacher:', error.response?.data || error.message);
      alert('Error: ' + (error.response?.data?.message || 'Failed to update teacher details.'));
    }
  };

  const handleDelete = () => {
    if (window.confirm('Are you sure you want to delete this teacher?')) {
      axios
        .delete(`https://kidsm.vercel.app/api/schools/teachers/${teacher?._id}`, {
          data: { schoolId },
        })
        .then((response) => {
          if (response.status === 200) {
            alert('Success: Teacher deleted successfully!');
            navigate(-1);
          }
        })
        .catch((error) => {
          console.error('Error deleting teacher:', error.response?.data || error.message);
          alert('Error: ' + (error.response?.data?.message || 'Failed to delete teacher.'));
        });
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh' }}>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2c3e50', mb: 3 }}>
          {teacher?.fullName || 'Unknown Teacher'}
        </Typography>

        <Card sx={{ p: 2, mb: 3, boxShadow: 3, bgcolor: '#fff' }}>
          <CardContent>
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#6200ee', mb: 1 }}>
              TSC Number
            </Typography>
            <Typography sx={{ color: '#333', mb: 2 }}>{teacher?.tscNumber || 'N/A'}</Typography>

            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#6200ee', mb: 1 }}>
              Phone Number
            </Typography>
            <Typography sx={{ color: '#333', mb: 2 }}>{teacher?.phoneNumber || 'N/A'}</Typography>

            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#6200ee', mb: 1 }}>
              Subject Specialization
            </Typography>
            <Typography sx={{ color: '#333', mb: 2 }}>{teacher?.subjectSpecialization || 'N/A'}</Typography>

            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#6200ee', mb: 1 }}>
              Email
            </Typography>
            <Typography sx={{ color: '#333', mb: 2 }}>{teacher?.email || 'N/A'}</Typography>

            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#6200ee', mb: 1 }}>
              Class Representing
            </Typography>
            <Typography sx={{ color: '#333', mb: 2 }}>{teacher?.classRepresenting || 'N/A'}</Typography>
          </CardContent>
        </Card>

        <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
          <Button
            variant="contained"
            sx={{ bgcolor: '#6200ee', flex: 1 }}
            onClick={() => setIsEditModalOpen(true)}
          >
            Edit Teacher
          </Button>
          <Button
            variant="contained"
            sx={{ bgcolor: '#d32f2f', flex: 1 }}
            onClick={handleDelete}
          >
            Delete Teacher
          </Button>
        </Box>

        {/* Edit Teacher Modal */}
        <Dialog open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)}>
          <DialogTitle>Edit Teacher Details</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              label="Full Name"
              value={editForm.fullName}
              onChange={(e) => setEditForm({ ...editForm, fullName: e.target.value })}
              margin="normal"
            />
            <TextField
              fullWidth
              label="Email"
              value={editForm.email}
              onChange={(e) => setEditForm({ ...editForm, email: e.target.value })}
              margin="normal"
            />
            <TextField
              fullWidth
              label="Phone Number"
              value={editForm.phoneNumber}
              onChange={(e) => setEditForm({ ...editForm, phoneNumber: e.target.value })}
              margin="normal"
            />
            <TextField
              fullWidth
              label="Subject Specialization"
              value={editForm.subjectSpecialization}
              onChange={(e) => setEditForm({ ...editForm, subjectSpecialization: e.target.value })}
              margin="normal"
            />
            <TextField
              fullWidth
              label="TSC Number"
              value={editForm.tscNumber}
              onChange={(e) => setEditForm({ ...editForm, tscNumber: e.target.value })}
              margin="normal"
            />
            <TextField
              fullWidth
              label="Class Representing"
              value={editForm.classRepresenting}
              onChange={(e) => setEditForm({ ...editForm, classRepresenting: e.target.value })}
              margin="normal"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setIsEditModalOpen(false)} color="secondary">
              Cancel
            </Button>
            <Button onClick={handleEdit} color="primary">
              Save Changes
            </Button>
          </DialogActions>
        </Dialog>
      </motion.div>
    </Container>
  );
};

export default TeacherDetails;